const baseButtonContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "button",
    file: {},
    isUpdated: false,
  },
  translation: {
    id: "",
    name: "",
    translationableId: "",
    translationableType: "Resource",
    adminId: "",
    languageId: "",
    flag: true,
    isUpdated: false,
  },
};

const createButtonEntry = (title: string, key: string) => ({
  title,
  content: {
    ...baseButtonContent,
    data: {
      ...baseButtonContent.data,
      key,
    },
    translation: {
      ...baseButtonContent.translation,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: true,
});

const buttonEntries = [
  { title: "Back", key: "backButton" },
  { title: "Back Arrow", key: "backArrowButton" },
  { title: "Shuffle", key: "shuffleButton" },
  { title: "Submit", key: "submitButton" },
  { title: "Profile", key: "profileButton" },
  { title: "Play", key: "playButton" },
  { title: "Claim", key: "claimButton" },
  { title: "Gift", key: "giveButton" },
  { title: "Share", key: "shareButton" },
  { title: "Retry", key: "retryButton" },
  { title: "New", key: "new" },
  { title: "Recent", key: "recent" },
  { title: "Private Button", key: "privateButton" },
];

const gameButtons = buttonEntries.map(({ title, key }) => createButtonEntry(title, key));

export { gameButtons };
